/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PromoResponseList } from '../../models/promo-response-list';

export interface PromosGet$Params {
  page: number;
}

export function promosGet(
  http: HttpClient,
  rootUrl: string,
  params: PromosGet$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<PromoResponseList>> {
  const rb = new RequestBuilder(rootUrl, promosGet.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PromoResponseList>;
      }),
    );
}

promosGet.PATH = '/promos';
